import UserList from '../components/UserList/UserList';

export default function Users() {

    return(
             <UserList />
    )
}